var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{attrs:{"id":"users","service":_vm.userService,"url":"administrators","color":"admin","tableName":"Administradores","headers":_vm.headers,"filters":_vm.filters,"tableType":"complex"}})}
var staticRenderFns = []

export { render, staticRenderFns }